var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlug = function SvgPlug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.807.284a.97.97 0 0 1 0 1.371l-1.86 1.86 1.538 1.538 1.86-1.86a.97.97 0 0 1 1.371 1.371l-1.86 1.86.92.92a1.94 1.94 0 0 1-.483 3.096l-5.56 2.865a2.91 2.91 0 0 1-3.39-.53l-.373-.373-3.315 3.314a.97.97 0 1 1-1.371-1.371l3.314-3.315-.374-.374a2.909 2.909 0 0 1-.529-3.389l2.865-5.56a1.94 1.94 0 0 1 3.095-.484l.92.92 1.86-1.859a.97.97 0 0 1 1.372 0ZM4.419 8.155l2.865-5.56 6.121 6.121-5.56 2.865a.97.97 0 0 1-1.13-.177l-2.12-2.119a.97.97 0 0 1-.176-1.13Z"
  })));
};
export default SvgPlug;